import React, { useState } from 'react'
import btnImg from './assets/images/btn.svg'
import styles from './assets/styles/modal.styles'
import { makeStyles } from '@material-ui/core/styles'
import FadeInHOC from '../FadeInHOC'
import closeIcon from './assets/images/closeIcon.svg'
import clsx from 'clsx'
import { Magnifier } from 'react-image-magnifiers'
import { DettagliPageConfig } from '../../configuration'

const useStyles = makeStyles(styles)

export default function PhotoModal({ img, zoomedImg }) {
    const [dialog, setDialogOpen] = useState({
        open: false,
        animate: false
    })
    const [isImageZoomed, setImageZoomed] = useState(false)
    const handleToggleDialog = () => {
        setDialogOpen({ animate: true, open: !dialog.open })
    }
    const classes = useStyles()
    return (
        <>
            <div
                className={clsx(
                    classes.paper,
                    !dialog.open && 'dialog-fadeOut',
                    dialog.open && 'dialog-fadeIn',
                    !dialog.animate && 'hideDialog'
                )}
            >
                <span className={classes.wrapper} >
                    <img onClick={handleToggleDialog} className={classes.closeBtn} alt='close button' src={closeIcon} />
                    <Magnifier
                        className='photo-modal'
                        imageSrc={img}
                        largeImageSrc={zoomedImg}
                        touchActivation='doubleTap'
                        mouseActivation='doubleClick'
                        onZoomStart={() => setImageZoomed(true)}
                        onZoomEnd={() => setImageZoomed(false)}
                    />
                    <p className={clsx(classes.accesibility, isImageZoomed && 'helper-text-fadeOut')} >{DettagliPageConfig.modal[0]}</p>
                    <p className={clsx(classes.accesibility, !isImageZoomed && 'helper-text-fadeOut')} >{DettagliPageConfig.modal[1]}</p>
                </span>
            </div>
            <FadeInHOC rootClass={classes.root} >
                <span className={classes.zoomImg} >
                    <img onClick={handleToggleDialog} className={classes.image} src={img} alt='nature' />
                    <img onClick={handleToggleDialog} className={classes.zoomBtn} alt='zoom in button' src={btnImg} />
                </span>
            </FadeInHOC>
        </>
    )
}
